import angular from 'angular';

import * as actions from '../../../store/actions';

const mapStateToScope = (state) => ({
  subComponent: state.statsbar.activeComponent,
  activeIpWhitelist: state.ipwhitelist.activeIpWhitelist,
});

angular
  .module('myConsultApp')
  .controller(
    'ipWhitelistCreateEditController',
    ($ngRedux, $rootScope, $scope, $timeout, $http, ENV) => {
      $scope.initData = () => {
        $scope.currentIpWhitelist = {
          name: '',
          ip_address: '',
        };
        $scope.ipWhitelistProcessing = false;
        $scope.error = {
          highlightedFields: {},
          details: [],
        };
        $scope.title = 'ADD IP';
      };

      $scope.init = () => {
        $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
      };

      $scope.applyError = (error) => {
        const errorData = error.data['ip-white-list'];
        const details = [];

        Object.keys(errorData).map((key) => {
          if (typeof errorData[key] === 'string') {
            $scope.error.highlightedFields[key] = [errorData[key]];
          } else if (Array.isArray(errorData[key])) {
            $scope.error.highlightedFields[key] = errorData[key];
          } else {
            $scope.error.highlightedFields[key] = Object.values(errorData[key]);
          }
        });

        if (error.status === 500) {
          details.push([
            'There was an error with your request. Please try again in a few minutes.',
          ]);
        } else if (error.status === 400) {
          if (Object.keys($scope.error.highlightedFields).length > 0) {
            details.push('Please fix the highlighted field(s).');
          }
        } else {
          details.push(error.statusText);
        }
        $scope.error.details = details;
      };

      $scope.applySuccess = (keepPage = false) => {
        $scope.close();
        $rootScope.getData(keepPage);
      };

      $scope.deleteEntry = () => {
        if ($scope.currentIpWhitelist.id) {
          $scope.ipWhitelistProcessing = true;
          $scope
            .deleteIpWhitelist($http, ENV, $scope.currentIpWhitelist.id)
            .then(() => {
              $timeout(() => {
                $scope.ipWhitelistProcessing = false;
                $scope.applySuccess(true);
              });
            })
            .catch((error) => {
              $timeout(() => {
                $scope.ipWhitelistProcessing = false;
                $scope.applyError(error);
              });
            });
        }
      };

      $scope.submitIpWhitelist = () => {
        const payload = {
          'ip-white-list': $scope.currentIpWhitelist,
        };
        const currentIpWhitelistId = $scope.currentIpWhitelist.id;
        $scope.ipWhitelistProcessing = true;
        $scope.error = {
          highlightedFields: {},
          details: [],
        };

        if (!$scope.currentIpWhitelist.id) {
          $scope
            .createIpWhitelist($http, ENV, payload)
            .then(() => {
              $timeout(() => {
                $scope.ipWhitelistProcessing = false;
                $scope.applySuccess();
              });
            })
            .catch((error) => {
              $timeout(() => {
                $scope.ipWhitelistProcessing = false;
                $scope.applyError(error);
              });
            });
        } else {
          $scope
            .updateIpWhitelist($http, ENV, currentIpWhitelistId, payload)
            .then(() => {
              $timeout(() => {
                $scope.ipWhitelistProcessing = false;
                $scope.applySuccess(true);
              });
            })
            .catch((error) => {
              $timeout(() => {
                $scope.ipWhitelistProcessing = false;
                $scope.applyError(error);
              });
            });
        }
      };

      $scope.close = () => {
        $scope.setIpWhitelist(null);
        $rootScope.closeComponent();
      };

      $scope.clearForm = () => {
        if ($scope.ipWhitelistForm) {
          $scope.ipWhitelistForm.$setUntouched();
          $scope.ipWhitelistForm.$setPristine();
        }
      };

      $scope.$watch('activeIpWhitelist', () => {
        if ($scope.activeIpWhitelist) {
          $scope.title = 'EDIT IP';
          $scope.currentIpWhitelist = angular.copy($scope.activeIpWhitelist);
        } else {
          $scope.initData();
        }
      });

      $scope.$watch('subComponent', (newValue, oldValue) => {
        if (oldValue === 'create-ip-whitelist' || oldValue === 'edit-ip-whitelist') {
          $scope.initData();
          $scope.clearForm();
        }
      });

      $scope.init();
      $scope.initData();
      $scope.$on('$destroy', $scope.unsubscribe);
    },
  )
  .directive('ipWhitelistCreateEdit', () => {
    return {
      templateUrl: 'templates/v2/ip-whitelist-create-edit.html',
    };
  });
